/**
 * "Ready to publish?" gadget on the project Home: the release gate's rules (the Quality tab's), failing ones first, with
 * "n of N pass" and a link to Quality. Before the checks ran once it says so; nothing is invented.
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useQualityGate from '../../hooks/useQualityGate';
import { GadgetSkeleton } from './gadgets/GadgetCard';

const MARKS = { pass: ['✓', 'is-pass'], fail: ['✕', 'is-fail'], unknown: ['○', 'is-unknown'] };
const ORDER = { fail: 0, unknown: 1, pass: 2 };
const SHOWN = 5;

/** The rules that count (not switched off), failing first. */
export const gateRules = (gate) => (Array.isArray(gate?.rules) ? gate.rules : [])
  .filter((rule) => rule.status && rule.status !== 'off')
  .sort((a, b) => (ORDER[a.status] ?? 1) - (ORDER[b.status] ?? 1));

export default function ReadyToPublish({ projectId, onOpenQuality = null }) {
  const { gate, loading } = useQualityGate(projectId);
  const [all, setAll] = useState(false);
  const rules = gateRules(gate);
  const passing = rules.filter((rule) => rule.status === 'pass').length;
  return (
    <div className="ph-card" data-testid="ready-to-publish">
      <div className="ph-card-head">
        <h2 className="ph-card-title">Ready to publish?</h2>
        {rules.length > 0 && <span className="ph-muted ph-small">{passing} of {rules.length}</span>}
        {onOpenQuality && <button className="ph-link ph-card-links" onClick={onOpenQuality} type="button">Quality</button>}
      </div>
      {rules.length === 0 && loading && <GadgetSkeleton label="Reading the checks…" rows={4} />}
      {rules.length === 0 && !loading && <p className="ph-quiet">No check has run yet. Run them in Quality to see what blocks Publish.</p>}
      {rules.length > 0 && (
        <>
          <div aria-hidden="true" className="rp-bar"><div className="rp-fill" style={{ width: `${Math.round((passing / rules.length) * 100)}%` }} /></div>
          <ul className="rp-list">
            {(all ? rules : rules.slice(0, SHOWN)).map((rule) => {
              const [mark, tone] = MARKS[rule.status] || MARKS.unknown;
              // A rule failed by a missing check (no tests, no coverage report) names the gap: it never passes on its own.
              return <li className={tone} data-testid={`rp-rule-${rule.id}`} key={rule.id}><span aria-hidden="true">{mark}</span> {rule.status === 'fail' && rule.missing ? <><strong>Missing: {rule.gap || 'a check'}</strong> · {rule.label}</> : rule.label}</li>;
            })}
          </ul>
          {rules.length > SHOWN && (
            <button aria-expanded={all} className="ph-link rp-more" onClick={() => setAll(!all)} type="button">{all ? 'Show fewer' : `and ${rules.length - SHOWN} more`}</button>
          )}
        </>
      )}
    </div>
  );
}

ReadyToPublish.propTypes = { onOpenQuality: PropTypes.func, projectId: PropTypes.string };
